var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-no-wrap text-example",staticStyle:{"width":"8rem"}},[_vm._v(" This text should overflow the parent. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }